import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { IcoStar, Select } from '../../../components'
import './csatcliente.scss'
import Filter from './filter/filter'
import Grafico from './grafico'
import { filterHandle } from './redux/csatclienteActions'
import { setInfoEmpresa, setProjeto } from '../../../layout/redux/layoutActions'
import Video from '../../videos/video'
import CriarDashboardButton from '../../dashboard/criardashboardbutton'
import { modalOpen } from '../../../layout/redux/layoutActions'
import Criar from '../../dashboard/criar'


export default () => {
  const dispatch = useDispatch()
  const { filters, empresas, empresa, sistema} = useSelector(state=> state.layoutState)
  const { totalAvaliacao, projeto, filtersProvisorio, projetos } = useSelector(state=> state.csatclienteState)

  const nlsContexto = require(`../../centralAjuda/nlscontexto/${sistema.idioma}.json`)

  const nls = require(`./nls/${sistema.idioma}.json`) 

  //USADO CASO O USUÁRIO DER REFRESH NA PÁGINA
  useEffect(() => {
  const wasRefreshed = sessionStorage.getItem('wasRefreshed')
  
  if (wasRefreshed === 'true' && projeto && projeto.id) {
    sessionStorage.removeItem('wasRefreshed')
    dispatch(setProjeto(projeto)) // ← Isso já dispara toda a cadeia!
  }

  const handleBeforeUnload = () => {
    sessionStorage.setItem('wasRefreshed', 'true')
  }
  
  window.addEventListener('beforeunload', handleBeforeUnload)
  return () => window.removeEventListener('beforeunload', handleBeforeUnload)
}, [projeto, dispatch])



  useEffect(()=> {
    if (projeto.id) {
      dispatch(filterHandle({projetoID: projeto.id, empresaId: empresa.empresaId, params: filters, filtersProvisorio, typeSelect: filters.typeSelect, idioma: sistema.idiomaIdValue}))
    }
  }, [projeto, empresa])

  const handleFormFilter = (e) => {
    dispatch(setProjeto(e.value))
  }

  const handleFormFilterEmpresa = (e) => {
    dispatch(setInfoEmpresa(e.value))
  }

  const handleAbrirCriarDashboard = () => {
  dispatch(modalOpen('criar'))
}

  
  return (
    <div className='box-csatcliente'>
      <div className='box-csatcliente-topinfo'>
        <div>
          <div className='box-csatcliente-topinfo-select'>
            <Select 
              name='projeto'
              label={nls.projeto}
              options={projetos}
              selected={projeto}
              action={(e)=> handleFormFilter(e)}
              selectedItem={false}
              optionLabel='nomeProjeto'
              optionValue='id'
            />
          </div>
          <div className='box-csatcliente-topinfo-select'>
            <Select 
              name='empresa'
              label={nls.empresaanalisada}
              options={empresas}
              selected={empresa}
              action={(e)=> handleFormFilterEmpresa(e)}
              selectedItem={false}
              optionLabel='descricaoEmpresa'
              optionValue='empresaId'
            />
          </div>
        </div>
        <div className='box-csatcliente-topinfo-avaliacao'>
            <label>{nls.numerodeavaliacoes}</label>
            <IcoStar />
            <strong>{totalAvaliacao?totalAvaliacao:0}</strong>
        </div>
      </div>
      <Filter />

      <div className="box-comentarios-video">
        <Video videoName="video8" />

        {projeto?.tipoProjetoId &&
        projeto.tipoProjetoId !== 2 &&
        filters?.ciclo &&
        filters.ciclo.anoMesCiclo && (
            <CriarDashboardButton
              onClick={handleAbrirCriarDashboard}
            />
        )}

      </div>
      
      <Grafico nlsContexto={nlsContexto} />

      <Criar />
      
    </div>
  )
}
